import ResultsPage from "./results-page-container";

export default ResultsPage;
